import { SVG_ENUM } from "enums";
import {
  CLOSE_INVESTMENT_CONFIGS,
  CloseInvestmentModalConfig,
} from "../CloseInvestmentModal/closeInvestmentConfigs";

export interface GetContextMenuItemsParams {
  item: any;
  isOwn: boolean;
  isArchived: boolean;
  isAdmin: boolean;
  isStocksOrShares: boolean;
  hasTransactions: boolean;
  isOther: boolean;
  isPreciousMetals: boolean;
  isReliance: boolean;
  slug: string;
  setEditItem: (d: any) => void;
  setCloseItem: (d: { item: any; config: CloseInvestmentModalConfig } | null) => void;
  setDeleteItem: (d: any) => void;
  setDeleteShareItem: (d: any) => void;
  setAddTransactionItem: (d: {
    item: any;
    defaultType: "buy" | "sell";
    currentQuantity?: number;
  }) => void;
  setEditCompanyItem: (d: any) => void;
  openSellModal: (d: any) => void;
  openAddSharesModal: (d: any) => void;
  setSellAssetAdminItem: (d: any) => void;
  handleStatusChange: (item: any, status: "active" | "withdrawn" | "hidden") => void;
}

export const getContextMenuItems = ({
  item,
  isOwn,
  isArchived,
  isAdmin,
  isStocksOrShares,
  hasTransactions,
  isOther,
  isPreciousMetals,
  isReliance,
  slug,
  setEditItem,
  setCloseItem,
  setDeleteItem,
  setDeleteShareItem,
  setAddTransactionItem,
  setEditCompanyItem,
  openSellModal,
  openAddSharesModal,
  setSellAssetAdminItem,
  handleStatusChange,
}: GetContextMenuItemsParams) => {
  return [
    ...(isOwn && !isStocksOrShares && !(slug === "crypto" && item.investmentOrigin === "reliance")
      ? [
          {
            name: "Edytuj",
            svg: SVG_ENUM.EDIT,
            action: (d: any) => setEditItem(d),
          },
        ]
      : []),
    ...(isAdmin && isReliance && !isStocksOrShares
      ? [
          {
            name: "Edytuj",
            svg: SVG_ENUM.EDIT,
            action: (d: any) => setEditItem(d),
          },
        ]
      : []),
    ...(slug === "investment_policy" && !isArchived && !(isAdmin && isReliance)
      ? [
          {
            name: "Zamknij aktywo",
            svg: SVG_ENUM.CLOSE,
            action: (d: any) =>
              setCloseItem({
                item: d,
                config: CLOSE_INVESTMENT_CONFIGS.policy,
              }),
          },
        ]
      : []),
    ...(slug === "treasury_bonds" && !isArchived && !(isAdmin && isReliance)
      ? [
          {
            name: "Zamknij aktywo",
            svg: SVG_ENUM.CLOSE,
            action: (d: any) =>
              setCloseItem({
                item: d,
                config: CLOSE_INVESTMENT_CONFIGS.treasuryBonds,
              }),
          },
        ]
      : []),
    ...((slug === "artwork" || slug === "precious_stones") && !isArchived && !(isAdmin && isReliance)
      ? [
          {
            name: "Zamknij aktywo",
            svg: SVG_ENUM.CLOSE,
            action: (d: any) =>
              setCloseItem({
                item: d,
                config:
                  slug === "precious_stones"
                    ? CLOSE_INVESTMENT_CONFIGS.preciousStones
                    : CLOSE_INVESTMENT_CONFIGS.artwork,
              }),
          },
        ]
      : []),
    ...(isPreciousMetals && !isArchived && !(isAdmin && isReliance)
      ? [
          {
            name: "Zamknij aktywo",
            svg: SVG_ENUM.CLOSE,
            action: (d: any) =>
              setCloseItem({
                item: d,
                config: CLOSE_INVESTMENT_CONFIGS.preciousMetals,
              }),
          },
        ]
      : []),
    ...(slug === "real_estate" && !isArchived && !(isAdmin && isReliance)
      ? [
          {
            name: "Zamknij aktywo",
            svg: SVG_ENUM.CLOSE,
            action: (d: any) =>
              setCloseItem({
                item: d,
                config: CLOSE_INVESTMENT_CONFIGS.realEstate,
              }),
          },
        ]
      : []),
    ...(slug === "loans" && !isArchived && !(isAdmin && isReliance)
      ? [
          {
            name: "Zamknij aktywo",
            svg: SVG_ENUM.CLOSE,
            action: (d: any) =>
              setCloseItem({
                item: d,
                config: CLOSE_INVESTMENT_CONFIGS.loan,
              }),
          },
        ]
      : []),
    ...(isOther && !isArchived && !(isAdmin && isReliance)
      ? [
          {
            name: "Zamknij aktywo",
            svg: SVG_ENUM.CLOSE,
            action: (d: any) =>
              setCloseItem({
                item: d,
                config: CLOSE_INVESTMENT_CONFIGS.otherAsset,
              }),
          },
        ]
      : []),
    ...(isStocksOrShares && (item.origin === "other" || (isAdmin && isReliance))
      ? [
          {
            name: "Edytuj",
            svg: SVG_ENUM.EDIT,
            action: (d: any) => setEditCompanyItem(d),
          },
        ]
      : []),
    ...(hasTransactions && !isArchived && (!isAdmin || (isAdmin && isReliance))
      ? [
          {
            name: "Dodaj  transakcję",
            svg: SVG_ENUM.COINS_HAND,
            action: (d: any) =>
              setAddTransactionItem({
                item: d,
                defaultType:
                  isAdmin && isReliance ? "sell"
                  : !isAdmin && !isOwn && (slug === "crypto" || slug === "currencies") ? "sell"
                  : isOwn && !isArchived ? "sell"
                  : "buy",
              }),
          },
        ]
      : []),
    ...(isStocksOrShares && !isArchived && !(isAdmin && isReliance && item.status === "hidden")
      ? [
          {
            name: "Dodaj transakcję",
            svg: SVG_ENUM.COINS_HAND,
            action: (d: any) =>
              isAdmin && isReliance ? openAddSharesModal(d) : openSellModal(d),
          },
        ]
      : []),
    ...(isAdmin && isReliance && !isStocksOrShares && !hasTransactions && !isArchived &&
        slug !== "currencies" && slug !== "crypto" && item.status !== "sold"
      ? [
          {
            name: "Sprzedaj aktywo",
            svg: SVG_ENUM.COINS_HAND,
            action: (d: any) => setSellAssetAdminItem(d),
          },
        ]
      : []),
    ...(isOwn && !isStocksOrShares
      ? [
          {
            name: "Usuń",
            svg: SVG_ENUM.TRASH,
            action: (d: any) => setDeleteItem(d),
          },
        ]
      : []),
    ...(isOwn && isStocksOrShares
      ? [
          {
            name: "Usuń",
            svg: SVG_ENUM.TRASH,
            action: (d: any) => setDeleteShareItem(d),
          },
        ]
      : []),
    ...(isAdmin && isReliance && !isArchived && item.status !== "withdrawn" && item.status !== "sold"
      ? [
          ...(item.status !== "hidden"
            ? [
                {
                  name: "Ukryj",
                  svg: SVG_ENUM.CROSSED_EYE,
                  action: (d: any) => handleStatusChange(d, "hidden"),
                },
              ]
            : [
                {
                  name: "Pokaż",
                  svg: SVG_ENUM.EYE,
                  action: (d: any) => handleStatusChange(d, "active"),
                },
              ]),
          {
            name: "Wycofaj",
            svg: SVG_ENUM.STOP_SIGN,
            action: (d: any) => handleStatusChange(d, "withdrawn"),
          },
        ]
      : []),
    ...(isAdmin && isReliance && !isArchived && item.status === "withdrawn" && item.status !== "sold"
      ? [
          {
            name: "Przywróć",
            svg: SVG_ENUM.ARROW_UNDO,
            action: (d: any) => handleStatusChange(d, "active"),
          },
        ]
      : []),
  ];
};
